import { MakeCall } from 'ha/services/apiV2/createMakeCall';
import { QualificationRequirementDefault } from './types/QualificationRequirement';
import { RequiredDocuments } from './types/RequiredDocuments';

export default (makeCall: MakeCall) =>
  (applyToExistingListing: boolean, data: Array<RequiredDocuments>) =>
    makeCall<QualificationRequirementDefault>(
      'PUT',
      `/api/v2/qualification/requirements/defaults/`,
      {
        data: {
          applyToExistingListing,
          documents: data,
        },
      },
    );
